import React from 'react';
import './WhatsAppButton.css';
import whatsappLogo from '../assets/logo/whatsapp_logo.png';

const phoneNumber = '+601112870256';
const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^\d]/g, '')}`;


const WhatsAppButton: React.FC = () => (
  <a
    href={whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
  >
    <span className="whatsapp-bubble">Chat with us on WhatsApp</span>
    <img
      src={whatsappLogo}
      alt="WhatsApp Logo"
      width={64}
      height={64}
      style={{ borderRadius: '50%' }}
    />
  </a>
);

export default WhatsAppButton;
